import momenttz from 'moment-timezone';
// import { data } from '../../Mock/AssociatesReport/index';

import Api from 'Shared/Services/Api/index';
import GetSystemAuthUtil from 'Shared/Utils/ConfigEnvironment/GetSystemAuth/index';
import { IAssociatesReport, IAssociatesReportFilters, IAssociatesReportResponse } from '../../Interface/index';
import convertToNumber from 'Shared/Utils/ConvertToNumber';

const validFilters = (element: IAssociatesReport, filters: IAssociatesReportFilters) => {
  let isFilter = true
  if (filters.active && filters.active !== 'Todos' && element?.active?.toString() !== filters.active) {
    isFilter = false
  }
  if (filters.codigo && Number(element.codigo) !== Number(filters.codigo)) {
    isFilter = false
  }
  if (filters.documento && element.documento !== filters.documento) {
    isFilter = false
  }
  if (filters.nome && !element.nome?.includes(filters.nome)) {
    isFilter = false
  }
  if (!element.active) {
    isFilter = false
  }

  return isFilter;
}

export const getAssociatesReportService = async (params: IAssociatesReportFilters) => {
  return new Promise<IAssociatesReportResponse>(async (resolve, reject) => {
    let _retAssociatesReport: [IAssociatesReport?] = [];
    let regReturn: IAssociatesReportResponse = {
      status: '200',
      message: '',
    };

    try {
      let _config = {
        "systemauth": GetSystemAuthUtil(process.env.REACT_APP_ENVIRONMENT)
      };
      await Api.get('/associadorelatorio', { params: _config })
        .then(resp => {

          let _arrayResume: [IAssociatesReport?] = [];
          if (resp.data.data && resp.data.data.length > 0) {
            for (let reg of resp.data.data) {
              const _item = {
                id: reg.guidcontrol.value,
                codigo: reg.codigo.value ? reg.codigo.value.padStart(4, '0') : '0000',
                nome: reg.nome.value,
                documento: reg.documento.value,
                codigoPrincipal: reg.codigoPrincipal.value ? reg.codigoPrincipal.value.padStart(4, '0') : '0000',

                valorBase: Number(reg.valorBase.value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                qtdeBase: Number(reg.qtdeBase.value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                metaMix: Number(reg.metaMix.value).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).padStart(4, '0'),
                metaMixPrincipal: Number(reg.metaMixPrincipal.value).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).padStart(4, '0'),
                mix: Number(reg.mix.value).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).padStart(4, '0'),
                mixPrincipal: Number(reg.mixPrincipal.value).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).padStart(4, '0'),
                percentMix: Number(reg.metaMix.value ? (Number(reg.mix.value) / Number(reg.metaMix.value)) * 100 : 0).toLocaleString("pt-BR", { minimumIntegerDigits: 2, minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                metaFaturamento: Number(reg.metaFaturamento.value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                faturamento: Number(reg.faturamento.value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                percentFaturmento: Number(reg.metaFaturamento.value ? (Number(reg.faturamento.value) / Number(reg.metaFaturamento.value)) * 100 : 0).toLocaleString("pt-BR", { minimumIntegerDigits: 2, minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                criadoEm: momenttz(reg.criadoEm.value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm'),
                alteradoEm: momenttz(reg.alteradoEm.value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm'),

                active: reg.active.value === 1 ? true : false,
                agrupador: Number(`${reg.codigoPrincipal.value ? reg.codigoPrincipal.value : reg.codigo.value}`).toLocaleString("pt-BR", { minimumIntegerDigits: 2, minimumFractionDigits: 0, maximumFractionDigits: 0 }).padStart(4, '0'),
              }

              if (validFilters(_item, params)) {
                _retAssociatesReport.push(_item);

                let _aux = _arrayResume.find((r) => r !== undefined && r.codigoPrincipal === _item.codigoPrincipal);
                if (_aux) {
                  const _index = _arrayResume.indexOf(_aux);

                  let _newReg: IAssociatesReport = {
                    id: _aux.id,
                    codigo: _aux.codigo,
                    nome: _aux.nome,
                    documento: _aux.documento,
                    codigoPrincipal: _aux.codigoPrincipal,
                    valorBase: _aux.valorBase,
                    qtdeBase: _aux.qtdeBase,
                    metaMix: _aux.metaMix,
                    mix: _aux.mix,
                    metaMixPrincipal: _aux.metaMixPrincipal,
                    mixPrincipal: _aux.mixPrincipal,
                    percentMix: _aux.percentMix,
                    metaFaturamento: _aux.metaFaturamento,
                    faturamento: _aux.faturamento,
                    percentFaturmento: _aux.percentFaturmento,
                    criadoEm: _aux.criadoEm,
                    alteradoEm: _aux.alteradoEm,
                    active: _aux.active,
                    agrupador: _aux.agrupador,
                  };

                  const _auxValorBase = convertToNumber(_aux.valorBase);
                  const _valorBase = convertToNumber(_item.valorBase);
                  const _novoValorBase = Number(_auxValorBase) + Number(_valorBase);
                  _newReg.valorBase = Number(_novoValorBase).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                  const _auxQtdeBase = convertToNumber(_aux.qtdeBase);
                  const _qtdeBase = convertToNumber(_item.qtdeBase);
                  const _novoQtdeBase = Number(_auxQtdeBase) + Number(_qtdeBase);
                  _newReg.qtdeBase = Number(_novoQtdeBase).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                  const _auxMetaMix = convertToNumber(_aux.metaMix);
                  const _metaMix = convertToNumber(_item.metaMix);
                  const _novoMetaMix = Number(_auxMetaMix) + Number(_metaMix);
                  _newReg.metaMix = Number(_novoMetaMix).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });

                  const _auxMix = convertToNumber(_aux.mix);
                  const _mix = convertToNumber(_item.mix);
                  const _novoMix = Number(_auxMix) + Number(_mix);
                  _newReg.mix = Number(_novoMix).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                  _newReg.percentMix = Number(_novoMetaMix ? (_novoMix / _novoMetaMix) * 100 : 0).toLocaleString("pt-BR", { minimumIntegerDigits: 2, minimumFractionDigits: 2, maximumFractionDigits: 2 });

                  // const _auxMetaMixPrincipal = convertToNumber(_aux.metaMixPrincipal);
                  const _metaMixPrincipal = convertToNumber(_item.metaMixPrincipal);
                  const _novoMetaMixPrincipal = Number(_metaMixPrincipal); // Number(_auxMetaMixPrincipal) + Number(_metaMixPrincipal);
                  _newReg.metaMixPrincipal = Number(_novoMetaMixPrincipal).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });

                  _newReg.metaFaturamento = Number(convertToNumber(_aux.metaFaturamento) + convertToNumber(_item.metaFaturamento)).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  _newReg.faturamento = Number(convertToNumber(_aux.faturamento) + convertToNumber(_item.faturamento)).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  _newReg.percentFaturmento = Number(convertToNumber(_aux.metaFaturamento) > 0 ? (convertToNumber(_aux.faturamento) / convertToNumber(_aux.metaFaturamento)) * 100 : 0).toLocaleString("pt-BR", { minimumIntegerDigits: 2, minimumFractionDigits: 2, maximumFractionDigits: 2 });

                  if (_item.codigo === _item.codigoPrincipal && _aux.codigo !== _aux.codigoPrincipal) {
                    _newReg.codigo = _item.codigo;
                    _newReg.documento = _item.documento;
                    _newReg.nome = _item.nome;
                    _newReg.mixPrincipal = _item.mixPrincipal;
                    _newReg.metaMixPrincipal = _item.metaMixPrincipal;
                  }

                  _arrayResume[_index] = _newReg;
                } else {
                  _arrayResume.push(_item);
                }

              }
            }
          }
          regReturn.list = _retAssociatesReport;
          regReturn.listResume = _arrayResume;
          resolve(regReturn);
        })
        .catch(error => {
          console.log(error);
          let msgerror = error.stack ? error.stack : 'Ocorreu um erro!';
          if (error.response && error.response.data) {
            msgerror = error.response.data.msgErr;
          }
          if (error.response && error.response.result) {
            msgerror = error.response.result.msgErr;
          }

          regReturn.status = '400';
          regReturn.message = msgerror;
          regReturn.msgErro = JSON.stringify(error);
          reject(regReturn)
        });
    }
    catch (err) {
      console.log('AssociatesReport.Service.getAll.err');
      console.log(err);

      let _msgError = 'Ocorreu um erro!';
      regReturn.status = '400';
      regReturn.message = _msgError;
      regReturn.msgErro = JSON.stringify(err);
      reject(regReturn)
    }
  });
}
